import css from 'styled-jsx/css';
import { colors } from '../../../../themes';

export default css`
  .placeholder {
    background: ${colors.grayExtraLight};
    color: ${colors.grayLight};
    display: block;
    height: 100%;
    width: 100%;
  }

  .placeholder span {
    left: 50%;
    position: absolute;
    top: 50%;
    margin: -25px 0 0 -25px;
  }
`;



// WEBPACK FOOTER //
// ./app/common/Snippet/shared/SnippetPicturePlaceholder/styles.js